import { render, staticRenderFns } from "./RomaModalTop.vue?vue&type=template&id=6d37beb0"
import script from "./RomaModalTop.vue?vue&type=script&lang=ts"
export * from "./RomaModalTop.vue?vue&type=script&lang=ts"
import style0 from "./RomaModalTop.vue?vue&type=style&index=0&id=6d37beb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports